export default __webpack_public_path__ + "static/media/VEB_DentalMaxCare.a57ca2ae.png";